import {
  Button,
  Box,
  Icon,
  useToast,
  Spinner,
  HStack,
  Text,
} from "@chakra-ui/react";
import { Resolver, UseFormRegister, useForm } from "react-hook-form";
import { MdCheck } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ModalAlert } from "@/components/ModalStyled/Modal";
import { useState } from "react";

interface Props<T extends { [x: string]: any }> {
  isLoading: boolean;
  defaultValues?: { [x: string]: any };
  handleSave: (values: T) => Promise<any>;
  resolver: Resolver<T>;
  title: string;
  children: (
    register: UseFormRegister<T>,
    errors: any,
    control?: any,
    watch?: any,
    setValue?: any
  ) => React.ReactElement;
  headerExtraContent?: (watch: any, setValue: any) => React.ReactNode;
}


export function UpsertFormModal<T extends { [x: string]: any }>({
  isLoading,
  defaultValues,
  handleSave,
  resolver,
  children,
  title,
  headerExtraContent,
}: Props<T>) {
  const navigate = useNavigate();
  const toast = useToast();
  const [isRetornoOpen, setIsRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState("");
  const [tipoRetorno, setTipoRetorno] = useState<"sucesso" | "erro">("sucesso");

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    control,
    watch,
    setValue,
  } = useForm<T>({
    resolver,
    values: defaultValues as T,
  });

  const _handleSave = async (data: T) => {
    try {
      await handleSave(data);

    } catch (e: any) {

    }
  };



  return (
    <>
      <ModalAlert
        isOpen={true}
        xIsback
        size="2xl"
        title={
          <HStack w={'100%'} justify="space-between" align="center">
            <HStack w={'100%'} justify={'flex-start'}>
              <Text  fontSize="xl">{title}</Text>
            </HStack>
            {headerExtraContent && headerExtraContent(watch, setValue)}
          </HStack>
        }
        body={
          isLoading ? (
            <Box textAlign="center">
              <Spinner />
            </Box>
          ) : (
            <Box as="form" onSubmit={handleSubmit(_handleSave)} px={1}>
              {children(register, errors, control, watch, setValue)}
            </Box>
          )
        }
        footer={
          <Button
            colorScheme="green"
            onClick={handleSubmit(_handleSave)}
            isLoading={isSubmitting}
            leftIcon={<Icon as={MdCheck} />}
          >
            Salvar 
          </Button>
        }
      />

      <ModalAlert
        isOpen={isRetornoOpen}
        onClose={() => {
          setIsRetornoOpen(false);
          if (tipoRetorno === "sucesso") navigate(-1);
        }}
        title={tipoRetorno === "sucesso" ? "Sucesso" : "Erro"}
        body={<Text>{mensagemRetorno}</Text>}
        footer={
          <Button onClick={() => setIsRetornoOpen(false)}>Fechar</Button>
        }
      />
    </>
  );
}
